import React from 'react';
import style from './style.module.scss';
import {Label as ProductLabel, renderLabelTooltip} from '../Label';
import {Typography} from 'components/Typography';
import {IProductSnippet, TProductLabel} from 'shared/types/productSnippet.types';

type TIsNewLabelProps = TProductLabel &
    Pick<IProductSnippet, 'id'> &
    Pick<IProductSnippet['analytics'], 'onStockClick'>;

export const IsNewLabel = (props: TIsNewLabelProps) => {
    const {code, title, id, url, tooltip, onStockClick} = props;

    return (
        <ProductLabel url={url} className={style.main} key={code} id={id} tooltip={renderLabelTooltip(tooltip)}>
            <Typography
                onClick={() => {
                    onStockClick(url);
                }}
                variant={'label-10-r'}
            >
                {title}
            </Typography>
        </ProductLabel>
    );
};
